angular.module('zc.zenclerkS')
  .component('zcsCampaignEditStepConfirm', {
    templateUrl: '/templates/zenclerk_s/sites/campaigns/edit/campaign_edit_step_confirm.html',
    require: {
      campaignEdit: '^zcsCampaignEdit'
    },
    controller: ZcsCampaignEditStepConfirmController
  });

ZcsCampaignEditStepConfirmController.$inject = ['ZcsEstimator', 'ZcsSegment', '$filter', 'currencies'];
function ZcsCampaignEditStepConfirmController(ZcsEstimator, ZcsSegment, $filter, currencies) {
  const vm = this;

  this.$onInit = () => {
    // variables
    vm.campaign = vm.campaignEdit.campaign;
    vm.project = vm.campaignEdit.project;
    vm.incentive = vm.campaignEdit.incentive;
    vm.currency = currencies[vm.project.currency];

    vm.segment = undefined;

    // actions
    vm.getSegmentLabel = ZcsSegment.getSegmentLabel;
    vm.isCouponStepOk = isCouponStepOk;
    vm.dateObjToDate = dateObjToDate;
  };

  function isCouponStepOk() {
    if(vm.incentive.has_price_limit && !vm.incentive.minimum_price) return false;
    return vm.campaignEdit.existingCouponCodes.indexOf(vm.incentive.coupon_code) < 0 &&
      vm.campaignEdit.incentive.coupon_code;
  }

  // TODO: move to some "lib"
  function dateObjToDate(dateObj) {
    if(!dateObj) return;
    return $filter('dateObjToDate')(dateObj);
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/sites/campaigns/edit/campaign_edit_step_confirm.js